import MarkdownRenderer from './MarkdownRenderer';
import type { LighthouseAudit } from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = { audit: LighthouseAudit };

const FilmstripAuditRenderer = ({ audit }: Props) => {
  if (!audit.details || !audit.details.items) {
    return <div>No filmstrip data available</div>;
  }

  return (
    <div className="fs--1">
      <MarkdownRenderer content={audit.description} />
      <div>
        {audit.details.items.map((item: any, idx: number) => (
          <img key={idx} src={item.data} alt={`Filmstrip ${idx}`} />
        ))}
      </div>
    </div>
  );
};

export default FilmstripAuditRenderer;
